/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { VDateInput } from "vuetify/labs/VDateInput";
import { VFileUpload, VFileUploadItem } from 'vuetify/labs/VFileUpload'
import { VTimePicker } from 'vuetify/labs/VTimePicker'

import { en, es } from "vuetify/locale";

// Composables
import { createVuetify } from "vuetify";

const odysseaTheme = {
  dark: false,
  colors: {
    background: "#F0F0F0",
    surface: "#FFFFFF",
    "surface-bright": "#FFFFFF",
    "surface-light": "#EEEEEE",
    "surface-variant": "#424242",
    "on-surface-variant": "#EEEEEE",
    primary: "#5096B4",
    "primary-darken-1": "#1F5592",
    secondary: "#DC917D",
    "secondary-darken-1": "#018786",
    error: "#B00020",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FB8C00",
    academy: "#E23A4B",
    employability: "#F8AB53",
    company: "#A1CAC9",
    admin: "#2ebbafff",
  },
  variables: {
    "border-color": "#000000",
    "border-opacity": 0.12,
    "high-emphasis-opacity": 0.87,
    "medium-emphasis-opacity": 0.6,
    "disabled-opacity": 0.38,
    "idle-opacity": 0.04,
    "hover-opacity": 0.04,
    "focus-opacity": 0.12,
    "selected-opacity": 0.08,
    "activated-opacity": 0.12,
    "pressed-opacity": 0.12,
    "dragged-opacity": 0.08,
    "theme-kbd": "#212529",
    "theme-on-kbd": "#FFFFFF",
    "theme-code": "#F5F5F5",
    "theme-on-code": "#000000",
  },
};

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  theme: {
    defaultTheme: "odysseaTheme",
    themes: {
      odysseaTheme,
    },
  },
  locale: {
    locale: "en-GB",
    fallback: "en",
    messages: { en, es },
  },
  defaults: {
    VTextField: {
      variant: "outlined",
    },
  },
  components: {
    VDateInput,
    VFileUpload,
    VFileUploadItem,
    VTimePicker,
  },
});
